import { Country } from '@commenda/prisma';
import { FeatureLaunch } from './featureLaunchEnum';
import { isFeatureLaunched } from './isFeatureLaunched';

export function supportedNewIncorporationOnboardingCountries(
  companyId?: number
): Country[] {
  return [
    isFeatureLaunched(FeatureLaunch.USCorporationOnboarding, companyId)
      ? Country.US
      : undefined,
  ].filter(Boolean) as Country[];
}
export function supportedIncorporationCountries(companyId?: number): Country[] {
  return [
    isFeatureLaunched(FeatureLaunch.USCorporationOnboarding, companyId)
      ? Country.US
      : undefined,
    isFeatureLaunched(FeatureLaunch.CACorporationOnboarding, companyId)
      ? Country.CA
      : undefined,
    isFeatureLaunched(FeatureLaunch.INCorporationOnboarding, companyId)
      ? Country.IN
      : undefined,
    isFeatureLaunched(FeatureLaunch.GBCorporationOnboarding, companyId)
      ? Country.GB
      : undefined,
    isFeatureLaunched(FeatureLaunch.AECorporationOnboarding, companyId)
      ? Country.AE
      : undefined,
    isFeatureLaunched(FeatureLaunch.SGCorporationOnboarding, companyId)
      ? Country.SG
      : undefined,
    isFeatureLaunched(FeatureLaunch.IECorporationOnboarding, companyId)
      ? Country.IE
      : undefined,
    isFeatureLaunched(FeatureLaunch.NLCorporationOnboarding, companyId)
      ? Country.NL
      : undefined,
    isFeatureLaunched(FeatureLaunch.ESCorporationOnboarding, companyId)
      ? Country.ES
      : undefined,
    isFeatureLaunched(FeatureLaunch.ITCorporationOnboarding, companyId)
      ? Country.IT
      : undefined,
    isFeatureLaunched(FeatureLaunch.FRCorporationOnboarding, companyId)
      ? Country.FR
      : undefined,
    isFeatureLaunched(FeatureLaunch.LUCorporationOnboarding, companyId)
      ? Country.LU
      : undefined,
    isFeatureLaunched(FeatureLaunch.BGCorporationOnboarding, companyId)
      ? Country.BG
      : undefined,
    isFeatureLaunched(FeatureLaunch.PHCorporationOnboarding, companyId)
      ? Country.PH
      : undefined,
    isFeatureLaunched(FeatureLaunch.CHCorporationOnboarding, companyId)
      ? Country.CH
      : undefined,
    isFeatureLaunched(FeatureLaunch.VGCorporationOnboarding, companyId)
      ? Country.VG
      : undefined,
    isFeatureLaunched(FeatureLaunch.MACorporationOnboarding, companyId)
      ? Country.MA
      : undefined,
    isFeatureLaunched(FeatureLaunch.BECorporationOnboarding, companyId)
      ? Country.BE
      : undefined,
    isFeatureLaunched(FeatureLaunch.UGCorporationOnboarding, companyId)
      ? Country.UG
      : undefined,
    isFeatureLaunched(FeatureLaunch.KECorporationOnboarding, companyId)
      ? Country.KE
      : undefined,
    isFeatureLaunched(FeatureLaunch.SKCorporationOnboarding, companyId)
      ? Country.SK
      : undefined,
    isFeatureLaunched(FeatureLaunch.SICorporationOnboarding, companyId)
      ? Country.SI
      : undefined,
    isFeatureLaunched(FeatureLaunch.NOCorporationOnboarding, companyId)
      ? Country.NO
      : undefined,
    isFeatureLaunched(FeatureLaunch.RSCorporationOnboarding, companyId)
      ? Country.RS
      : undefined,
    isFeatureLaunched(FeatureLaunch.TRCorporationOnboarding, companyId)
      ? Country.TR
      : undefined,
    isFeatureLaunched(FeatureLaunch.PLCorporationOnboarding, companyId)
      ? Country.PL
      : undefined,
    isFeatureLaunched(FeatureLaunch.AUCorporationOnboarding, companyId)
      ? Country.AU
      : undefined,
    isFeatureLaunched(FeatureLaunch.DECorporationOnboarding, companyId)
      ? Country.DE
      : undefined,
    isFeatureLaunched(FeatureLaunch.NZCorporationOnboarding, companyId)
      ? Country.NZ
      : undefined,
    isFeatureLaunched(FeatureLaunch.MXCorporationOnboarding, companyId)
      ? Country.MX
      : undefined,
    isFeatureLaunched(FeatureLaunch.BRCorporationOnboarding, companyId)
      ? Country.BR
      : undefined,
    isFeatureLaunched(FeatureLaunch.CLCorporationOnboarding, companyId)
      ? Country.CL
      : undefined,
    isFeatureLaunched(FeatureLaunch.COCorporationOnboarding, companyId)
      ? Country.CO
      : undefined,
    isFeatureLaunched(FeatureLaunch.ARCorporationOnboarding, companyId)
      ? Country.AR
      : undefined,
    isFeatureLaunched(FeatureLaunch.UYCorporationOnboarding, companyId)
      ? Country.UY
      : undefined,
    isFeatureLaunched(FeatureLaunch.SECorporationOnboarding, companyId)
      ? Country.SE
      : undefined,
    isFeatureLaunched(FeatureLaunch.PTCorporationOnboarding, companyId)
      ? Country.PT
      : undefined,
    isFeatureLaunched(FeatureLaunch.JPCorporationOnboarding, companyId)
      ? Country.JP
      : undefined,
    isFeatureLaunched(FeatureLaunch.ZACorporationOnboarding, companyId)
      ? Country.ZA
      : undefined,
    isFeatureLaunched(FeatureLaunch.FJCorporationOnboarding, companyId)
      ? Country.FJ
      : undefined,
    isFeatureLaunched(FeatureLaunch.CKCorporationOnboarding, companyId)
      ? Country.CK
      : undefined,
    isFeatureLaunched(FeatureLaunch.IDCorporationOnboarding, companyId)
      ? Country.ID
      : undefined,
    isFeatureLaunched(FeatureLaunch.KRCorporationOnboarding, companyId)
      ? Country.KR
      : undefined,
    isFeatureLaunched(FeatureLaunch.SACorporationOnboarding, companyId)
      ? Country.SA
      : undefined,
  ].filter(Boolean) as Country[];
}
